import { render, staticRenderFns } from "./CrmRelativeTable.vue?vue&type=template&id=cd69cdf0&scoped=true&"
import script from "./CrmRelativeTable.vue?vue&type=script&lang=js&"
export * from "./CrmRelativeTable.vue?vue&type=script&lang=js&"
import style0 from "./CrmRelativeTable.vue?vue&type=style&index=0&id=cd69cdf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd69cdf0",
  null
  
)

export default component.exports